<div class="container-fuid bg-white default-boxrounded dialog-withdraw p-3">
  <div class="row">
    <div class="col-7">
      @if (!multipleRequests) {
        <h2 translate="Dialog.DeleteTitleForOne"></h2>
      }
      @if (multipleRequests) {
        <h2 translate="Dialog.DeleteTitleForMultiple"></h2>
      }
    </div>
  </div>
  <div class="py-3">
    @if (!multipleRequests) {
      <span class="float-start" translate="Dialog.DeleteDescriptionForOne"></span>
    }
    @if (multipleRequests) {
      <span class="float-start" translate="Dialog.DeleteDescriptionForMultiple"></span>
    }
  </div>
  <div class="mt-2 mt-3 d-table w-100">
    <span class="float-start">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="closeModal()" translate="Button.Back"></button>
    </span>
    <span class="float-end">
      <button type="button" class="btn btn-sm btn-danger" (click)="TriggerDelete()" translate="Dialog.Delete"></button>
    </span>
  </div>
</div>